import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import Scriba from 'react-scriba';
import { EUIDatePicker } from '../EUI/EUIDatePicker';

/*
**************************************************************************************************************
PROPS :
    ATTRIBUTS :
        date    fromDate                            date de début
        date    toDate                              date de fin
        bool    isRequired                          détermine si DatePickers obligatoires ou non
    METHODES :
        void    onSelectDate(fromDate, toDate)      méthode appelée lorsque l'utilisateur sélectionne une date
**************************************************************************************************************
*/

export const FromDateToDatePicker = (props) => {

    const _onSelectFiltreFromDate = (date) => {
        const dateToUTC = Scriba.date().dateForceFormatUTC(date);
        const fromDate = dateToUTC;
        let toDate = props.toDate;

        if (toDate && fromDate.getTime() > toDate.getTime())
            toDate = dateToUTC; // fromDate ne peut être supérieur à toDate

        props.onSelectDate(fromDate, toDate);
    };

    const _onSelectFiltreToDate = (date) => {
        const dateToUTC = Scriba.date().dateForceFormatUTC(date);
        let fromDate = props.fromDate;
        const toDate = dateToUTC;

        if (fromDate && fromDate.getTime() > toDate.getTime())
            fromDate = dateToUTC; // fromDate ne peut être supérieur à toDate

        props.onSelectDate(fromDate, toDate);
    };

    return <Fragment>

        <EUIDatePicker
            isRequired={props.isRequired}
            label="A compter du"
            onSelectDate={date => _onSelectFiltreFromDate(date)}
            value={props.fromDate}
        />

        <EUIDatePicker
            isRequired={props.isRequired}
            label="Jusqu'au"
            onSelectDate={date => _onSelectFiltreToDate(date)}
            value={props.toDate}
        />

    </Fragment>
};

FromDateToDatePicker.propTypes = {
    isRequired: PropTypes.bool,
    onSelectDate: PropTypes.func.isRequired
};

FromDateToDatePicker.defaultProps = {
    isRequired: false
};